
//PRODUCTION

export const environment = {
  name: "prod",
  production: true, //means this is a production build, not deployed to production
  isDevMode: false,  //will not show DEV in header
  baseUrl: "https://webapi.gorpms.com", //PROD
  version: "2.4.5.20260709-0800"
};
